import React from 'react';
import { Container, Row, Col, Button, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import Input from '../../../components/UI/Input/Input';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import AutoComplete from '../../../components/UI/AutoComplete/AutoComplete';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextArea from '../../../components/UI/TextArea/TextArea';
import ImageUploader from '../../../components/UI/ImageUploader/ImageUploader';
import PdfUploader from '../../../components/UI/PdfUploader/PdfUploader';

const AddBook = () => {
  const { submitHandler, resetFormState, loading, field, authors, categories, createAuthor, back } = useForm();
  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('book.title.add')} subtitle={t('book.subTitle')} className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4 py-5 px-4">
              <form>
                <Row>
                  <Col md="6">
                    <Input type="text" placeholder={t('placeholder.ISBN')} label={t('label.ISBN')} {...field('ISBN')} />
                  </Col>
                  <Col md="6">
                    <AutoComplete
                      placeholder={t('placeholder.authors')}
                      label={t('label.authors')}
                      {...field('authors', 'multipleAutoComplete')}
                      data={authors}
                      valueObject="id"
                      titleObject="name"
                      addFunction={createAuthor}
                    />
                  </Col>
                  <Col md="6">
                    <AutoComplete
                      placeholder={t('placeholder.categories')}
                      label={t('label.categories')}
                      {...field('categories', 'multipleAutoComplete')}
                      data={categories}
                      valueObject="children_id"
                      titleObject="children_name"
                      groupByObject="category_name"
                    />
                  </Col>
                  <Col md="6">
                    <Input type="text" placeholder={t('placeholder.title')} label={t('label.title')} {...field('title')} />
                  </Col>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.publicationNumber')}
                      label={t('label.publicationNumber')}
                      {...field('publicationNumber')}
                    />
                  </Col>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.editionNumber')}
                      label={t('label.editionNumber')}
                      {...field('editionNumber')}
                    />
                  </Col>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.publishingHouse')}
                      label={t('label.publishingHouse')}
                      {...field('publishingHouse')}
                    />
                  </Col>{' '}
                  <Col md="6">
                    <Input
                      type="date"
                      placeholder={t('placeholder.releaseDate')}
                      label={t('label.releaseDate')}
                      {...field('releaseDate')}
                    />
                  </Col>
                  <Col md="6">
                    <TextArea
                      type="text"
                      placeholder={t('placeholder.summary')}
                      label={t('label.summary')}
                      {...field('summary')}
                      rows="4"
                    />
                  </Col>
                  <Col md="6">
                    <TextArea
                      type="text"
                      placeholder={t('placeholder.abstract')}
                      label={t('label.abstract')}
                      {...field('abstract')}
                      rows="4"
                    />
                  </Col>
                  <Col md="6">
                    <Input type="number" placeholder={t('placeholder.pages')} label={t('label.pages')} {...field('pages')} />
                  </Col>
                  <Col md="6">
                    <Input type="number" step="0.01" placeholder={t('placeholder.price')} label={t('label.price')} {...field('price')} />
                  </Col>
                  <Col md="6">
                    <ImageUploader type="file" accept="image/*" {...field('cover', 'file')} module="book" />
                  </Col>
                  <Col md="6">
                    <PdfUploader type="file" accept="application/pdf" {...field('pdf', 'file')} />
                  </Col>
                  <Col md="12" className="d-flex justify-content-end">
                    <Button theme="info" disabled={loading} onClick={() => back()}>
                      {t('annuler')}
                    </Button>
                    &nbsp; &nbsp;
                    <Button theme="success" type="button" disabled={loading} onClick={() => submitHandler()}>
                      {t('create')}
                    </Button>
                  </Col>
                </Row>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddBook;
